// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>4</span>&nbsp;&nbsp;Keep me, O Lord, from the hands of the wicked;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;protect me from the violent<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;who seek to make me stumble.<br> </p> </div></div>";
// Exports
module.exports = code;